/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import api from "@/domain/api/api.client"

export async function fetchNavigation() {
    return await api.get("api/admin/navigation/getFullNavigation")
}
